import(/* webpackMode: "eager" */ "/vercel/path0/loyalty-app/node_modules/next/dist/client/link.js")